
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#F44336","stroke":"#F44336","stroke-miterlimit":"10"}},[_c('path',{attrs:{"d":"M21.09 21.132H.78a.27.27 0 01-.24-.14.28.28 0 01-.01-.28L10.69.882c.1-.19.41-.19.5 0l10.15 19.84c.04.09.04.19-.01.28-.05.09-.14.13-.24.13zm-19.84-.56h19.38l-9.69-18.94-9.69 18.94z"}}),_c('path',{attrs:{"d":"M10.94 15.182a.28.28 0 01-.28-.28v-8.03a.28.28 0 11.56 0v8.03c0 .15-.12.28-.28.28zM10.89 18.491a1.129 1.129 0 110-2.26c.63 0 1.13.51 1.13 1.13 0 .63-.5 1.13-1.13 1.13zm0-1.7a.57.57 0 100 1.14c.32 0 .57-.25.57-.57 0-.31-.26-.57-.57-.57z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .242)","d":"M0 0h21.88v21.39H0z"}})])])])
          )
        }
      }
    